module.exports = __webpack_public_path__ + "media/kevin2.38715698.mp3";